import { render } from "./IntellifloOfficePlansTable.vue?vue&type=template&id=b9c6c0e2&scoped=true"
import script from "./IntellifloOfficePlansTable.vue?vue&type=script&lang=js"
export * from "./IntellifloOfficePlansTable.vue?vue&type=script&lang=js"

import "./IntellifloOfficePlansTable.vue?vue&type=style&index=0&id=b9c6c0e2&scoped=true&lang=css"

import exportComponent from "/tmp/build_1a3e5399/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9c6c0e2"]])

export default __exports__